<template>
  <wrapper>
    <div class="row">
      <div class="col l10 offset-l1 m12 s12">
        <div class="card">
          <div class="card-title">
            <div class="row"></div>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col l4 m12 s12">
                <select v-model="type">
                  <option value="romaji">Romaji</option>
                  <option value="kanji">Kanji</option>
                  <option value="furigana">Furigana</option>
                  <option value="meaning">Meaning</option>
                </select>
              </div>
              <div class="col l8 m12 s12">
                <input type="text" v-model="value" placeholder="Your input here" />
              </div>
            </div>
            <div class="row">
              <div class="col s12 center">
                <button class="btn" @click="search">Search</button>
              </div>
            </div>
          </div>
        </div>
        <div  style="padding:20px;" v-if="words!=null">
          <table class="table" v-if="words.length>0">
            <tr>
              <th>No</th>
              <th>Romaji</th>
              <th>Kanji</th>
              <th>Furigana</th>
              <th>Meaning</th>
              <th>Part of Speech</th>
              <th>JPL Level</th>
              <th>Book Name</th>

              <th>Actions</th>
            </tr>
            <tr v-for="(item,index) in words" v-bind:key="item.id">
              <td>{{ index+1 }}</td>
              <td>{{ item.romaji }}</td>
              <td>{{ item.kanji }}</td>
              <td>{{ item.furigana }}</td>
              <td>{{ item.meaning }}</td>
              <td>{{ item.part_of_speech }}</td>
              <td>{{ item.level.name }}</td>
              <td>{{ item.book.name }}</td>

              <td>
                <button @click="showDetail(item)" class="btn btn-primary small">View</button>
              </td>
            </tr>
            <detail :show="show" @close="show=false" :data="current_data"></detail>
          </table>
          <div class="row center" v-else>
            <h5>No Words Match</h5>
          </div>
        </div>
      </div>
    </div>
  </wrapper>
</template>
<script>
import Detail from './Detail.vue';
import { sendDataToDict } from "./../../misc/server.js";
export default {
  data() {
    return {
      type: null,
      value: null,
      words: null,
      loading: false,
      show:false,
      current_data:null,
    };
  },
  methods: {
    async search() {
      if (this.type && this.value) {
        this.loading = true;
        var response = await sendDataToDict("word/search", {
          type: this.type,
          value: this.value
        });
        this.loading = false;
        this.words = response;
      } else {
        alert("Some fields are required");
      }
    },
     showDetail(item)
       {
           this.show=true;
           this.current_data=item;
       }
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});
  },
  updated() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});
  },
  components: 
  {
    "detail":Detail,
  }
};
</script>
<style lang="scss" scoped>
.card {
  margin-top: 50px;
}
</style>